import { render, staticRenderFns } from "./SignalIntermediateCatchEvent.vue?vue&type=template&id=b4601906&scoped=true&"
import script from "./SignalIntermediateCatchEvent.vue?vue&type=script&lang=js&"
export * from "./SignalIntermediateCatchEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4601906",
  null
  
)

export default component.exports